export default __webpack_public_path__ + "static/step0102-16fc2baf03ecd157db64cb7051a5e424.jpg";